module.exports = __webpack_public_path__ + "media/images/skyeye-3fe50d8b72dc6333e783fe5019ae509e.png";